<div *ngIf="dataIsLoaded">
  <section *ngIf="!inShareTableMarket">
    <u-hero src="hero-opportunity"></u-hero>
    <!--section padding will be inside the component-->
    <section (deferLoad)="lazyLoad[1] = true">
      <u-boss src="opportunity-boss" *ngIf="lazyLoad[1]"></u-boss>
    </section>
    <section (deferLoad)="lazyLoad[2] = true">
      <u-be src="opportunity-be" *ngIf="lazyLoad[2]"></u-be>
    </section>
    <span (deferLoad)="lazyLoad[3] = true">
      <u-hero src="hero-opportunity2" noChevron *ngIf="lazyLoad[3]">
        <a *ngIf="showEnrollmentLink()" href="{{ enrollmentLink | async }}" class="btn btn-primary">{{
          'my-usana.enrollment-text' | i18n : 'usanadotcom'
        }}</a>
      </u-hero>
    </span>
  </section>

  <div *ngIf="inShareTableMarket">
    <u-share-table src="share-usana"></u-share-table>
  </div>
</div>
